import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { TGetPostByDateInterval } from './types'

// Handle schedules
export const getSchedulesThunk = createAsyncThunk(
  'calendar/getSchedulesThunk',
  async (data: TGetSchedulesData, { getState, rejectWithValue, ...thunkApi }) => {
    try {
      const responseGetSchedule: AxiosResponse<any> = await axios.get(
        `/projects/${data.id}/posts/pending-approval/${data.start}/${data.end}`
      )

      let result = responseGetSchedule.data.data.post_schedules
      result.forEach((schedule: any) => {
        let can_approve_post_socials_ids: any[] =[];
        let can_unapprove_post_socials: any[] =[];
            schedule.post.post_socials.forEach((post_social: any)=>{
              if(post_social.is_approved){
                can_unapprove_post_socials.push(post_social.id)
              } else {
                can_approve_post_socials_ids.push(post_social.id)
              }
            })

        schedule.post.can_approve_post_socials = can_approve_post_socials_ids
        schedule.post.can_unapprove_post_socials = can_unapprove_post_socials
      })

      return responseGetSchedule.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const createPostThunk = createAsyncThunk(
  'calendar/createPostThunk',
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const responseCreatePost: AxiosResponse<any> = await axios.post(`/posts`, data)
      return responseCreatePost.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const getPostsByDateIntervalThunk = createAsyncThunk(
  'posts/getPostByDateIntervalThunk',
  async (
    { project_id, date_start, date_finish }: TGetPostByDateInterval,
    { getState, rejectWithValue, ...thunkApi }
  ) => {
    try {
      const responseGetPostByDateInterval: AxiosResponse<any> = await axios.get(
        `/posts/${project_id}/${date_start}/${date_finish}`
      )
      return responseGetPostByDateInterval.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const softDeletePostThunk = createAsyncThunk(
  'managePost/softDeletePostThunk',
  async (post_id: number, { rejectWithValue, dispatch }) => {
    try {
      const responseUpdatePost: AxiosResponse<any> = await axios.delete(`/posts/${post_id}`)
      return responseUpdatePost.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const batchSoftDeletePostsThunk = createAsyncThunk(
  'managePost/batchSoftDeletePostsThunk',
  async (post_ids: number[], { rejectWithValue, dispatch }) => {
    try {
      const responseUpdatePost: AxiosResponse<any> = await axios.delete(`/posts`, {
        data: { post_ids }
      })
      return responseUpdatePost.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const createLabelThunk = createAsyncThunk(
  'calendar/createLabelThunk',
  async (data: TCreateLabelData, { rejectWithValue, dispatch }) => {
    try {
      const responseCreateLabel: AxiosResponse<any> = await axios.post(`/daylabels`, data)
      return responseCreateLabel.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const updateLabelThunk = createAsyncThunk(
  'calendar/updateLabelThunk',
  async (data: TUpdateLabelData, { rejectWithValue, dispatch }) => {
    try {
      const responseCreateLabel: AxiosResponse<any> = await axios.put(
        `/daylabels/${data.day_label_id}`,
        data
      )
      return responseCreateLabel.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export const deleteLabelThunk = createAsyncThunk(
  'calendar/deleteLabelThunk',
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      await axios.delete(`/daylabels/${id}`)
      return id
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

export type TGetSchedulesData = {
  id: number
  start: string
  end: string
}
type TCreateLabelData = {
  project_id: number
  text: string
  color: string
  date: string
}

type TUpdateLabelData = TCreateLabelData & { day_label_id: number }
